const usingServiceAdvantage = {
  en: {
    title: 'Streamline Your Dim Sum Experience',
    desc: 'Faster service, more efficiency, and more profit for every Dim Sum dish',
    items: [
      {
        title: 'Streamline Service, Delight Customers',
        image: `${process.env.ASSETS_PREFIX}/businesstype/dim-sum_meals-1.jpg`,
        items: [
          {
            desc: 'Self service with QR Code/Tablet Ordering generates higher order volume, higher table turn over, and happier customers',
          },
          {
            desc: 'Shave minutes off every order with handheld POS systems at every table',
          },
          {
            desc: 'Use third-party integrations to streamline the delivery order processing process',
          },
        ],
      },
      {
        title: 'Save Big on Redundant Tasks',
        image: `${process.env.ASSETS_PREFIX}/businesstype/dim-sum-pay-sign.jpg`,
        items: [
          {
            desc: 'Use digital menus and skip print menus to save on costs',
          },
          {
            desc: 'Cut down on labor costs to handle dine-in and delivery orders',
          },
        ],
      },
      {
        title: 'More Savings, More Speed, More Profit',
        image: `${process.env.ASSETS_PREFIX}/businesstype/dim-sum-making-order.jpg`,
        items: [
          {
            desc: 'Our POS system saves the average restaurant up to $8,000/month in labor costs',
          },
          {
            desc: 'Remove redundant costly tasks, which can boost sales volume, tips, staff productivity, and your bottom line!',
          },
        ],
      },
    ],
  },
  zh: {
    title: '简化早茶店的服务流程',
    desc: '为餐厅节约人工并给顾客提供更快速的用餐体验',
    items: [
      {
        title: '简化运营流程',
        image: `${process.env.ASSETS_PREFIX}/businesstype/dim-sum_meals-1.jpg`,
        items: [
          {
            desc: '对于堂食点餐，顾客使用扫码/平板一键自助下单，订单直达后厨，无需人工传递，减少漏单/错单概率',
          },
          {
            desc: '对于堂食结账，服务员使用手持POS实现桌边结账，无需多次往返柜台打印小票、刷卡、打印收据',
          },
          {
            desc: '餐厅经理也可以受益于电子小费，无需每天花2小时手动录入小费',
          },
          {
            desc: '对于外卖订单，餐厅使用第三方外卖平台整合的功能简化外卖订单处理流程。无需手动输入外卖订单，所有外卖订单一键确认后直接送厨',
          },
        ],
      },
      {
        title: '减少人工成本',
        image: `${process.env.ASSETS_PREFIX}/businesstype/dim-sum-pay-sign.jpg`,
        items: [
          {
            desc: '顾客自助点餐后，餐厅无需安排这么多服务员提供纸质菜单，等待顾客划单',
          },
          {
            desc: '服务员专注于上菜和提供更好的服务上，达到更少的人力投入、更高的效率的结果',
          },
          {
            desc: '高峰时期也无需安排一个服务员专门输入外卖订单',
          },
          {
            desc: '利用POS产品减少人工重复性操作，将有限的人力投入到更有价值的服务上',
          },
        ],
      },
      {
        title: '提升餐厅利润',
        image: `${process.env.ASSETS_PREFIX}/businesstype/dim-sum-making-order.jpg`,
        items: [
          {
            desc: '我们的POS产品帮助您在等位、点单、结账、订单管理等环节显著减少人力成本',
          },
          {
            desc: '关注顾客复购率，善用会员、积分、礼品卡、营销短信等方式发展您的回头客，提升营业额',
          },
          {
            desc: '自动化呈现餐厅订单、餐品、营业额等报表数据，帮助您更好地制定策略',
          },
        ],
      },
    ],
  },
};

export default usingServiceAdvantage;
